import React, {useState} from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Modal from "../../Modal";
import {CgMoreVerticalO} from "react-icons/cg";

const Vleugels = () => {
    const [show, setShow] = useState({});

    const toggle = (index) => {
        let state = {...show}
        state[index] = !(state[index] ?? false);
        setShow(state);
    };

    const Title = ({index, title}) => (
        <h3 onClick={() => toggle(index)} style={{cursor: "pointer"}}>
            <div style={{marginRight: '5px'}}>{title}</div>
            <div><CgMoreVerticalO /></div>
        </h3>
    )

    return (
        <Modal title={'HOE MAAK JE SAMEN HET VERSCHIL?'}
               image={'https://care-free.app/wp-content/uploads/2024/01/Hoowy_Vleugels_RolloverActive.png'}>
            <div>
                <p>
                    In <b>stap 2</b> van de <b>meldcode</b> ga je in <b>overleg met (deskundige) collega’s en/of Veilig
                    thuis</b> over <b>de signalen</b> die je in kaart hebt gebracht en de <b>zorgen</b> die je hebt <b>vanuit
                    stap 1</b>. Bij een vermoeden van seksueel misbruik kun je ook advies vragen bij het Centrum Seksueel
                    Geweld. De informatie hieronder helpt je hierbij.
                </p>

                <h2>SAMENWERKEN MET (DESKUNDIGE) COLLEGA’S EN/OF VEILIG THUIS</h2>

                <p>
                    Wanneer je een <b>vermoeden hebt van kindermishandeling</b> door het oppikken van een of
                    meerdere <b>signalen</b> is het belangrijk om dit <b>bespreekbaar te maken met (deskundige) collega’s en
                    eventueel Veilig Thuis, het Centrum Seksueel Geweld of het Landelijk Expertise Centrum Eer Gerelateerd
                    Geweld</b>. Door het er samen over te hebben draag je <b>gezamenlijk de verantwoordelijkheid</b> en kun
                    je samen de <b>vervolgstappen</b> bedenken.
                </p>

                <p>
                    De vraag die je aan collega’s en/of Veilig Thuis, het Centrum Seksueel Geweld of het Landelijk Expertise
                    Centrum Eer Gerelateerd Geweld kunt stellen is: ‘Is hier sprake van een ernstig opvoedprobleem of
                    kindermishandeling, is er mogelijk een andere oorzaak of is er helemaal niks aan de hand?’ Ook
                    informatie over andere kinderen in het gezin neem je hierin mee.
                </p>

                <p>
                    Je neemt <b>signalen</b> serieus, redeneert het niet weg, en bent je <b>bewust</b> van je eigen emoties.
                    Emoties als angst, boosheid, ongeloof worden op een <b>professionele manier besproken en
                    geanalyseerd</b> in een gesprek met (deskundige) collega’s en/of Veilig Thuis, het Centrum Seksueel
                    Geweld of het Landelijk Expertise Centrum Eer Gerelateerd Geweld.
                </p>

                <p>
                    <b>
                        Het gesprek helpt je om de eigen gedachten te ordenen, om de argumenten te toetsen aan een andere
                        mening en om samen een voorlopig plan op te stellen.
                    </b>
                </p>

                <Title index={'1'} title={'Veilig thuis'}/>
                {show['1'] &&
                    <div>
                        <p>
                            Veilig Thuis is er <b>voor advies en ondersteuning en het melden van huiselijk geweld en
                            kindermishandeling.</b> Voor jezelf, maar ook als je je zorgen maakt over de veiligheid van iemand
                            anders kun je een beroep doen op Veilig Thuis; ook als professional. Of je nu vermoedens hebt, of het
                            zeker weet. Je zorgen delen is een belangrijke eerste stap.
                        </p>

                        <p>
                            Als je belt met Veilig Thuis krijg je een medewerker aan de lijn, die aandachtig naar je verhaal
                            luistert. Deze medewerker zet samen met je alles op een rij, <b>beantwoordt vragen en geeft advies</b>.
                            Als nodig kijkt hij of zij samen met jou welke hulp er nodig is.
                        </p>

                        <p>
                            <b>
                                Je kunt anoniem de situatie bespreekbaar maken en advies vragen.<br/>
                                Je kunt als professional niet anoniem melden, tenzij er sprake is van onveiligheid voor de melder.
                            </b>
                        </p>

                        <p>
                            <img
                                src={'https://care-free.app/wp-content/uploads/2024/01/veilig-thuis-logo234x.png'}
                                alt='veilig thuis'
                                style={{
                                    maxWidth: "80px",
                                }}
                            />
                        </p>
                        <p>
                            <b>Wil je contact leggen met Veilig Thuis voor advies en/of melden?</b><br/>
                            Bel gratis (24/7) naar 0800-2000.<br/>
                            <a href={'https://veiligthuis.nl/'} target={'_blank'}>www.veiligthuis.nl</a>
                        </p>
                    </div>
                }

                <Title index={'2'} title={'CENTRUM SEKSUEEL GEWELD'}/>
                {show['2'] &&
                <div>
                    <p>
                        Als professional kun je te maken krijgen met situaties waarin sprake is van <b>seksueel
                        geweld/misbruik.</b><b>Heb je hulp nodig, twijfel je of zit je met vragen?</b> Dan kun je altijd <b>anoniem
                        en gratis contact</b> opnemen met het Centrum Seksueel Geweld.
                    </p>

                    <p>
                        <img
                            src={'https://care-free.app/wp-content/uploads/2024/01/CSG-logo-groot.png'}
                            alt='Centrum Seksueel Geweld'
                            style={{
                                maxWidth: "80px",
                            }}
                        />
                    </p>

                    <p>
                        Je kunt <b>bellen</b> naar <b>0800-0188</b>.<br/>
                        Je kunt ook <b>chatten</b> of het <b>contactformulier</b> van het centrum seksueel geweld invullen via
                        de <b>website</b>: <a href={'https://www.centrumseksueelgeweld.nl'}
                                              target={'_blank'}>www.centrumseksueelgeweld.nl</a>
                    </p>
                </div>
                }

                <Title index={'3'} title={'LANDELIJK EXPERTISE CENTRUM EER GERELATEERD GEWELD'}/>
                {show['3'] &&
                <div>
                    <p>
                        Als professional kun je te maken krijgen met situaties waarin sprake is van <b>Eer Gerelateerd Geweld. Heb je hulp nodig, twijfel je of zit je met vragen?</b> Dan kun je contact opnemen met het Landelijke Expertise Centrum Eer Gerelateerd Geweld (LEC EGG)
                    </p>

                    <p>
                        <img
                            src={'https://care-free.app/wp-content/uploads/2024/01/2560px-Logo_politie.svg_.png'}
                            alt={'Politie'}
                            style={{
                                maxWidth: "80px",
                            }}/>
                    </p>

                    <p>
                        Je kunt <b>bellen</b> naar <b>088-9648550</b>.<br/>
                        <b>Meer informatie:</b> <a
                        href={'https://www.politie.nl/informatie/contactpersonen-lec-egg-bij-de-politie.html'}
                        target={"_blank"}>www.politie.nl/informatie/contactpersonen-lec-egg-bij-de-politie.html</a>
                    </p>
                </div>
                }
            </div>
        </Modal>
    );
}


export default Vleugels;
